import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };

export const AdminAuditTab = () => {
  const [rows, setRows] = useState([]);
  const [check, setCheck] = useState(null);
  const load = useCallback(() => axios.get(`${API}/admin/audit-log?limit=200`, opts).then(r => setRows(r.data)).catch(() => toast.error('Registro non disponibile')), []);
  useEffect(() => { load(); }, [load]);
  const verify = () => axios.get(`${API}/admin/audit-log/verify`, opts).then(r => setCheck(r.data)).catch(() => toast.error('Verifica non riuscita'));

  return (
    <Card className="border border-border rounded-xl" data-testid="admin-audit-tab"><CardContent className="p-5 space-y-4">
      <div className="flex items-center gap-3">
        <Button size="sm" variant="outline" className="rounded-full" onClick={verify} data-testid="audit-verify-btn">Verifica integrità</Button>
        {check && <span className={`text-xs font-sans ${check.valid ? 'text-green-700' : 'text-destructive'}`} data-testid="audit-verify-result">
          {check.valid ? `Catena valida (${check.entries} voci)` : `Problemi rilevati: ${check.problems.length}`}</span>}
      </div>
      <div className="max-h-[480px] overflow-y-auto">
        {rows.map(r => (
          <div key={r.audit_id} className="flex flex-wrap gap-2 py-1.5 border-b border-border text-xs font-sans" data-testid={`audit-row-${r.seq}`}>
            <span className="font-mono text-muted-foreground">#{r.seq}</span>
            <span>{(r.at || '').slice(0, 19).replace('T', ' ')}</span>
            <Badge variant={r.outcome.startsWith('denied') ? 'destructive' : 'secondary'} className="text-[10px]">{r.outcome}</Badge>
            <span className="font-semibold">{r.action}</span>
            <span className="font-mono">{r.actor_user_id}</span>
            {r.target && <span className="text-muted-foreground">→ {r.target}</span>}
            <span className="text-muted-foreground">{r.path}</span>
          </div>
        ))}
      </div>
    </CardContent></Card>
  );
};
